import { render, staticRenderFns } from "./SupsisSVG.vue?vue&type=template&id=af465de2&scoped=true"
import script from "./SupsisSVG.vue?vue&type=script&lang=js"
export * from "./SupsisSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af465de2",
  null
  
)

export default component.exports